import React from 'react';

import { DeleteVariantIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './LastFaceDeleteConfirmation.module.sass';

export interface LastFaceDeleteConfirmationProps {
  onConfirm?: VoidFunction;
  onReject?: VoidFunction;
}

export function LastFaceDeleteConfirmation({
  onConfirm = undefined,
  onReject = undefined,
}: LastFaceDeleteConfirmationProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={st.Root}
      data-testid="confirmPopup"
    >
      <DeleteVariantIcon className={st.Icon} />

      <h5 className={st.Title}>
        {t('card-page:delete.last_face.title')}
      </h5>

      <div className={st.Message}>
        {t('card-page:delete.last_face.message')}
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          data-testid="utton-faceCard.confirmCancellButton"
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('btn.cancel')}
        </Control.Button>

        <Control.Button
          className={st.Action}
          data-testid="Button-faceCard.confirmDeleteButton"
          kind="negative"
          onClick={onConfirm}
        >
          {t('btn.delete')}
        </Control.Button>
      </div>
    </div>
  );
}
